import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Col } from '@h3/antd-vue';
let FormCol = class FormCol extends Vue {
    get colSpan() {
        if (typeof this.span === 'number') {
            return this.span;
        }
        return this.control.span;
    }
};
tslib_1.__decorate([
    Prop()
], FormCol.prototype, "control", void 0);
tslib_1.__decorate([
    Prop()
], FormCol.prototype, "span", void 0);
FormCol = tslib_1.__decorate([
    Component({
        name: 'form-col',
        components: {
            ACol: Col
        }
    })
], FormCol);
export default FormCol;
